import { getBaseURL } from '../../env/enviroment';
import { getAuthState } from '../components/sy-site-auth/store/store';
import * as languages from '../components/sy-site-language-buttons/assets/data/languages.json';

const utils = {
  getImageUrl: (classId: string, objectId: string, photoId: string): string => {
    const token = getAuthState('isAuthenticated') && getAuthState('user').token;
    const link = `${getBaseURL()}_classId/${classId}/_download/${objectId}/${photoId}${token ? `?accessToken=${token}` : ''}`;
    return link;
  },
  locationPathIsNotHome: () => {
    let value = true;
    for (let i = 0; i < languages.circleLanguages.length; i++) {
      if (window.location.pathname === languages.circleLanguages[i].link || window.location.pathname === languages.circleLanguages[i].link.concat('/')) {
        value = false;
        break;
      }
    }
    return value;
  }
};

export default utils;
